<h1 class="u-sr-only">{{ 'Profile.Menu.JoinRequests' | translate }}</h1>
<section class="c-section c-section--last u-no-pb" panel [isOpen]="true">
	<div class="c-section__header">
		<p class="c-section__title u-hidden@md-and-up">{{ 'Profile.Menu.JoinRequests' | translate }}</p>
	</div>
	<div class="c-section__content">
		<div class="o-grid">
			<div class="o-grid__cell c-cell">
				<card-join-requests></card-join-requests>
			</div>
		</div>
	</div>
</section>
